import React from 'react';
export function Header() {
  return <header className="w-full" data-id="element-94">
      <div className="bg-blue-600 text-white p-2 flex justify-between items-center" data-id="element-95">
        <div className="text-lg font-bold" data-id="element-96">HEALTHY SLEEP INSIDER</div>
        <nav className="hidden md:flex space-x-6" data-id="element-97">
          <a href="https://nuuvhome.com/products/ortholift-contour-pillow?variant=51566921744691" className="text-sm hover:underline" data-id="element-98">
            Order
          </a>

          <a href="https://nuuvhome.com/pages/contact-us" className="text-sm hover:underline" data-id="element-99">
            Contact
          </a>

          
        </nav>
      </div>
    </header>;
}